import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, useIntl} from "react-intl";
import {useHistory} from "react-router-dom";

import VariantBadge from "components/dashboard/VariantBadge";

import {Box} from "@mui/material";

import PriorityBadge from "../../StockAlertsTable/components/PriorityBadge";
import ProductImage from "../../../../TopTablesComponents/ProductImage";

import {greyishBlue100, greyishBlue600} from "assets/jss/main";

import {MarketplaceRoutes} from "utils/MarketplaceRoutes";
import {navigateOnClick} from "utils/navigateOnClick";

StockAlertMobileRow.propTypes = {
    product: PropTypes.object,
    rank: PropTypes.number,
    currency: PropTypes.string
}

function StockAlertMobileRow({rank, product, currency}) {
    const intl = useIntl();
    const history = useHistory();

    const { id, sku, name, brand, image, variants = [], priority, alerts, lostRevenue, retailerId } = product ?? {};

    return (
        <div
            onClick={(e) => navigateOnClick(e, MarketplaceRoutes.RETAILER_PRODUCT(retailerId, id), history)}
            style={{
                display: 'flex',
                flexDirection: 'row',
                padding: '14px',
                background: '#fff',
                marginBottom: '10px',
                border: `1px solid ${greyishBlue100}`,
                borderRadius: '12px',
                gap: '12px',
                cursor: 'pointer'
            }}
        >
            <div>
                <ProductImage rank={rank} image={image} name={name}/>
            </div>
            <div style={{display: "flex", flexDirection: "column", gap: "4px", width: '100%'}}>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center"}}>
                    <div style={{fontSize: '13px'}}>
                        <b>{alerts ?? 0}</b>
                        <span style={{fontSize: '10px', color: greyishBlue600}}>&nbsp; <FormattedMessage id="dashboard.stockAlerts.mobile.alerts" /></span>
                        <b style={{marginLeft: '8px'}}>{lostRevenue ? intl.formatNumber(lostRevenue, {
                            style: "currency",
                            currency: currency ?? "EUR",
                            maximumFractionDigits: 2
                        }) : 0}</b>
                    </div>
                    <PriorityBadge score={priority} />
                </div>
                <div>
                    <Box sx={{display: "flex", flexWrap: "wrap", gap: "4px"}}>
                        {(variants ?? []).map((v, i) => (
                            <VariantBadge key={i} value={v}/>
                        ))}
                    </Box>
                </div>
                <div style={{fontSize: '11px', color: greyishBlue600}}>
                    <FormattedMessage id="dashboard.common.ref" />. <span style={{fontWeight: 500}}>{sku}</span>
                </div>
                <div style={{
                    fontSize: '12px',
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden'
                }}>
                    <b>{brand}</b> - {name}
                </div>
            </div>
        </div>
    );
}

export default StockAlertMobileRow;
